var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"take_detail"},[_c('head-top',{attrs:{"head-title":"具体详情","go-back":"true"}}),_vm._v(" "),_c('div',{staticClass:"take_title"},[_c('div',{staticClass:"title border-bottom"},[_vm._v(_vm._s(_vm.details.title))])]),_vm._v(" "),_c('p',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.details.content)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-173815f6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/TakeInDetail.vue
// module id = t6hn
// module chunks = 0